import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class SecurityConfigService extends RLBaseService {
    
        static $inject = ["$resource", "$q"];
    
        constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
            super($resource);
        }
    
        saveRole(role: Models.IWFActionRole) {
            return this.toRLService<number>("/api/securityconfig/saverole").post(role).$promise;
        }
    
        deleteRole(roleID: number) {
            var data = {
                roleID: roleID
            };
            return this.toRLService<boolean>("/api/securityconfig/deleterole").post(data).$promise;
        }
    
        updateSequenceNumber(roleID: number, direction: boolean) {
            var data = {
                roleID: roleID,
                direction: direction
            };
            return this.toRLService<void>("/api/securityconfig/updateSequenceNumber").post(data).$promise;
        }
    
        getSecurityPolicyList() {
            return this.toRLService<Models.IAspNetSecurityPolicy>("/api/securityconfig/getsecuritypolicylist").getArray().$promise;
        }
    
        getSecurityPolicy(securityPolicyID: string) {
            var data = {
                securityPolicyID: securityPolicyID
            };
            return this.toRLService<Models.IAspNetSecurityPolicy>("/api/securityconfig/getsecuritypolicy").get(data).$promise;
        }
    
        createSecurityPolicy(policyTitle: string, policyType: number, policyDivGlobal: boolean) {
            var data = {
                policyTitle: policyTitle,
                policyType: policyType,
                policyDivGlobal: policyDivGlobal
            };
            return this.toRLService<Models.ICreatedGuidResponse>("/api/securityconfig/createsecuritypolicy").post(data).$promise;
        }
    
        updateSecurityPolicy(policyID: string, policyTitle: string, policyType: number, policyDivGlobal: boolean) {
            var data = {
                securityPolicyID: policyID,
                policyTitle: policyTitle,
                policyType: policyType,
                policyDivGlobal: policyDivGlobal
            };
            return this.toRLService<Models.ICreatedGuidResponse>("/api/securityconfig/updatesecuritypolicy").post(data).$promise;
        }
    
        deleteSecurityPolicy(securityPolicyID: string) {
            var data = {
                securityPolicyID: securityPolicyID
            };
            return this.toRLService<void>("/api/securityconfig/deletesecuritypolicy").post(data).$promise;
        }
    
        getPolicyTree(policyType: number) {
            var data = {
                policyType: policyType
            };
            return this.toRLService<Models.ISecurityTreeNode>("/api/securityconfig/getpolicytree").query(data).$promise;
        }
    
        getPolicyPermissions(securityPolicyID: string) {
            var data = {
                securityPolicyID: securityPolicyID
            };
            return this.toRLService<Models.IAspNetSecurityPolicyPermission>("/api/securityconfig/getpolicypermissions").query(data).$promise;
        }
    
        setPolicyPermissions(securityPolicyID: string, permissions: Models.IAspNetSecurityPolicyPermission[]) {
            var data = {
                securityPolicyID: securityPolicyID,
                permissions: permissions
            };
            return this.toRLService<void>("/api/securityconfig/setpolicypermissions").post(data).$promise;
        }
    
        getSecurityActivityTree() {
            return this.toRLService<Models.IAspNetSecurityActivity>("/api/securityconfig/getsecurityactivitytree").query().$promise;
        }
    
        createSecurityActivity(parentSecurityActivityID: string, activityTitle: string, activityDescription: string, activityKey: string) {
            var data = {
                parentSecurityActivityID: parentSecurityActivityID,
                activityTitle: activityTitle,
                activityDescription: activityDescription,
                activityKey: activityKey
            };
            return this.toRLService<void>("/api/securityconfig/createsecurityactivity").post(data).$promise;
        }
    
        updateSecurityActivity(securityActivityID: string, parentSecurityActivityID: string, activityTitle: string, activityDescription: string, activityKey: string) {
            var data = {
                securityActivityID: securityActivityID,
                parentSecurityActivityID: parentSecurityActivityID,
                activityTitle: activityTitle,
                activityDescription: activityDescription,
                activityKey: activityKey
            };
            return this.toRLService<void>("/api/securityconfig/updatesecurityactivity").post(data).$promise;
        }
    
        deleteSecurityActivity(securityActivityID: string) {
            var data = {
                securityActivityID: securityActivityID
            };
            return this.toRLService<void>("/api/securityconfig/deletesecurityactivity").post(data).$promise;
        }
    
        getCharacteristicPolicySummary(charTypeID: number, templateGroupID: number, templateID: number, charGroupID: number, charID: number) {
            var data = {
                charTypeID,
                templateGroupID,
                templateID,
                charGroupID,
                charID
            };
            return this.toRLService<Models.ICharacteristicPolicySummary>("/api/securityconfig/getcharacteristicpolicysummary").get(data).$promise;
        }
    }